export default "__VITE_ASSET__ZtNTNWuC__"